import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next"; import { useDispatch, useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { useAuthState } from "../../../../../../../../Helper/Context";
import { WardAndAreaPopUpGetTableDataAPI } from "../../../../../../../../Redux/EnchrochmentDashboardSlice/ViewScedulingSlice/CreateNewSchedulingSlice";
import { Loading } from "../../../../../../../../Helper/Loading";


export const WardGridPopup = (props) => {
    const { handleWardPopup, message, heading, Language, GridData } = props

    const dispatch = useDispatch()
    const userDetails = useAuthState();
    const { UserID, token } = userDetails
    const [searchParams] = useSearchParams()
    let DashSelect = searchParams.get("DashSelect");


    const [IsClear, setIsClear] = useState(false)
    const [PerPageCount, setPerPageCount] = useState(10)
    const [From, setFrom] = useState(1)
    const [To, setTo] = useState(10)
    const [CurrentPage, setCurrentPage] = useState(0)

    const [MonthValue, setMonthValue] = useState(sessionStorage.getItem('monthId'))
    const [YearValue, setYearValue] = useState(sessionStorage.getItem('yearId'))


    const { t } = useTranslation()

    useEffect(() => {
        const data = {
            M_FinacialYearID: YearValue,
            M_MonthID: MonthValue,
            T_Encroach_CreateSchedulingID: GridData.t_Encroach_CreateSchedulingID,
            M_WorkTypeID: DashSelect,
            Flag: 'SheduledWard',
            Language: Language.Label,
            M_UserID: UserID,
            FromTop: From,
            ToTop: '99999',
            token: token,
        }
        dispatch(WardAndAreaPopUpGetTableDataAPI({ data }))
    }, [YearValue, MonthValue, DashSelect, From, IsClear, Language.Label,])

    const { isLoading, tableData } = useSelector(state => state.WardAndAreaPopUpGetTableData)

    return (
        <>
            <div className="modal fade show" style={{ display: "flex", alignItems: 'center', backgroundColor: "#00000090" }}>
                <div className="modal-dialog modal-lg">
                    <div className="modal-content p-3">
                        <div className="modal-header pt-0">

                            <h5 className="card-title fw-bold" id="exampleModalLongTitle">
                                Ward
                            </h5>
                            <button onClick={() => handleWardPopup()} type="button" className="close" style={{ marginLeft: "auto" }}>
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        {isLoading && <Loading />}
                        <div className="modal-body">
                            <div className="row" >
                                <div className="col-12  " >
                                    <div className="table-responsive table-responsive-fix">
                                        <table className="table table-striped table-bordered">
                                            <thead className="header_position">
                                                <tr>
                                                    <th className="w-6 text-center">{t('EncroachmentDashboard.SrNo')}</th>
                                                    <th className="text-center">{t('EncroachmentDashboard.WardName')}</th>
                                                    {/* <th className="text-center">{t('EncroachmentDashboard.EmployeeName')}</th> */}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    tableData && tableData.length > 0 ? tableData.map((item) => {
                                                        return (
                                                            <tr>
                                                                <td className="py-1" align="center">{item.rowNum}</td>
                                                                <td className="text-center">{item.wardName ? item?.wardName : '-'}</td>
                                                                {/* <td className="text-center">---------------</td> */}
                                                            </tr>
                                                        )
                                                    })
                                                        :
                                                        <tr>
                                                            <td colSpan={11}>No data found ...</td>
                                                        </tr>
                                                }
                                            </tbody>
                                        </table>
                                    </div>

                                </div>


                            </div>
                        </div>

                    </div>
                </div>
            </div>

        </>);
}
